exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required-cls[data-v-2e0ebba0] {\n  color: #fd349c;\n  font-size: 0.072917rem;\n  margin-right: 0.026042rem;\n}", ""]);

// exports
